import React, { CSSProperties, FC } from 'react'

import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import cn from 'classnames'
import ReactModal from 'react-modal'

import styles from './info-popup.module.scss'
import Close from '../../assets/images/general-icons/close-white.svg'
import { Card } from '../Card'

export interface InfoPopupProps {
  customHeight?: string
  dismissButtonAttribute?: string
  showClose?: boolean
  isOpen: boolean
  onClose?: (e?: React.SyntheticEvent) => void
  header?: React.ReactNode
  body?: React.ReactNode
  getRef?: (ref: HTMLDivElement | null) => void
  refContainerClass?: string
  customPopUpStyles?: CSSProperties
  zIndex?: number
  dataTestId?: string
  className?: string
}

const modalCardStyles: React.CSSProperties = {
  margin: 0,
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'auto',
}

export const InfoPopup: FC<InfoPopupProps> = ({
  customHeight,
  dismissButtonAttribute = 'dismiss-modal',
  showClose = true,
  isOpen,
  onClose,
  header,
  body,
  getRef,
  refContainerClass,
  customPopUpStyles,
  zIndex,
  dataTestId = 'info-popup',
}) => {
  const appRoot = document.getElementById('root')
  if (appRoot) ReactModal.setAppElement(appRoot)

  if (!isOpen) return null

  return (
    <ReactModal
      onRequestClose={onClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: zIndex || 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: 30,
        },
        content: {
          position: 'relative',
          top: 'initial',
          right: 'initial',
          bottom: 'initial',
          left: 'initial',
          background: 'white',
          maxWidth: '100%',
          width: 520,
          maxHeight: '75vh',
          height: customHeight || 'auto',
          minHeight: '200px',
          marginRight: 16,
          marginLeft: 16,
          padding: 0,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: 4,
          ...customPopUpStyles,
        },
      }}
      isOpen={isOpen}
      aria={{
        labelledby: 'modal-header',
        describedby: 'modal-content',
      }}
    >
      <Card customWrapperStyle={modalCardStyles} dataTestId={dataTestId}>
        <div
          id="modal-header"
          className={cn(
            styles.modalHeader,
            showClose && styles.modalHeaderWithClose
          )}
        >
          {header}
          {showClose ? (
            <button
              id="close-modal"
              className={styles.closeBtn}
              onClick={onClose}
              data-testid="close-modal"
              data-item-category={TRACKING_CATEGORIES.GENERAL}
              data-item-name={dismissButtonAttribute}
            >
              <img src={Close} alt="Close" />
            </button>
          ) : null}
        </div>
        <div
          ref={getRef ? (ref) => getRef(ref) : null}
          className={getRef ? refContainerClass : undefined}
          id="modal-content"
        >
          {body}
        </div>
      </Card>
    </ReactModal>
  )
}

export default InfoPopup
